import { useAuth } from "@context/auth";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useTIMFunctionality from "./useTIMFunctionality";

export const useNavigaionRoutes = () => {
  const { t } = useTranslation(["menu", "skills-page", "common"]);
  const { t: modalT } = useTranslation(["modal"]);
  const { user } = useAuth();
  const { id } = useParams();

  const { corporateCatalogActionsCards, IsTIM } = useTIMFunctionality();

  let navigation: any[] = [];
  navigation = [
    {
      section: "catalog",
      text: t("catalog.title"),
      to: "catalog",
      description: t("catalog.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      iconText: "book",
      image: "section-catalog.jpg",
      children: [
        {
          section: "catalog.paths",
          text: t("paths"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "paths",
          image: "section-paths.jpg",
        },
        {
          section: "catalog.courses",
          text: t("courses"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "courses",
          image: "section-courses.jpg",
        },
        {
          section: "catalog.activities",
          text: t("activities"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "activities",
          image: "section-activities.jpg",
        },
        {
          section: "catalog.users-waiting",
          text: t("users-waiting"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "users-waiting",
          image: "section-users-waiting.jpg",
        },
      ],
    },
    {
      section: "corporate",
      text: t("corporate.title"),
      description: t("corporate.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "corporate",
      iconText: "corporate",
      image: "section-corporate.jpg",
      children: [
        {
          section: "skills.profession.retrieve",
          text: t("corporate.skills.title"),
          description: t("corporate.skills.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "skills",
          image: "section-skills.jpg",
        },

        {
          section: "corporate.users",
          text: t("corporate.users.title"),
          description: t("corporate.users.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "users",
          image: "section-users.jpg",
          iconText: "skills",
          settingsLink: "users-custom-fields",
          permissionSettingsLink: "usermgmt.corporates.custom_fields.read",
        },
        {
          section: "badge-certificates",
          text: t("corporate.badge-certificates.title"),
          description: t("corporate.badge-certificates.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "badge-certificates",
          image: "section-badge-certificate.jpg",
          children: [
            {
              section: "fe.badge.template.read",
              text: t("corporate.badge-certificates.badge.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "badges",
              image: "section-paths.jpg",
            },
            {
              section: "fe.certificate.template.read",
              text: t("corporate.badge-certificates.certificates.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "certificates",
              image: "section-courses.jpg",
            },
            {
              section: "fe.external.certificate.read",
              text: t("corporate.badge-certificates.skillBook.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "skillBook",
              image: "section-skillbook.jpg",
            },
          ],
        },
        {
          section: "corporate.groups",
          text: t("corporate.groups.title"),
          description: t("corporate.groups.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "groups",
          image: "section-corp-groups.jpg",
        },
        {
          section: "usermgmt.corporates.dynamic_groups.read",
          text: `${t("corporate.groups-dynamic.title")}`,
          description: t("corporate.groups-dynamic.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "groups-dynamic",
          image: "section-corp-groups.jpg",
        },
        {
          section: "users.site.retrieve",
          text: t("corporate.locations.title"),
          description: t("corporate.locations.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "locations",
          image: "section-locations.jpg",
        },
        {
          section: "corporate.physical-editions",
          text: t("corporate.physical-editions.title"),
          description: t("corporate.physical-editions.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "physical-editions",
          image: "section-corp-editions-physical.jpg",
        },
        {
          section: "corporate.virtual-editions",
          text: t("corporate.virtual-editions.title"),
          description: t("corporate.virtual-editions.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "virtual-editions",
          image: "section-corp-editions-virtual.jpg",
        },
        {
          section: "corporate.mediaLibrary",
          text: t("corporate.media-library.title"),
          description: t("corporate.media-library.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          iconText: "library",
          to: "media-library",
          image: "section-library.jpg",
        },
        {
          section: "corporate.initiative",
          text: t("corporate.initiative.title"),
          description: t("corporate.initiative.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "initiative",
          image: "section-corp-initiatives.jpg",
        },
        {
          section: "cms.wrapper.moderatedterms.read",
          text: t("corporate.terms.title"),
          description: t("corporate.terms.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "terms",
          image: "section-corp-initiatives.jpg",
        },
        {
          section: "corporate.catalog",
          text: t("corporate.catalog.title"),
          description: t("corporate.catalog.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          iconText: "book",
          to: "catalog",
          image: "section-catalog.jpg",
          actionsCard: IsTIM() ? corporateCatalogActionsCards : [],
          children: [
            {
              section: "corporate.catalog.paths",
              text: t("paths"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "paths",
              image: "section-paths.jpg",
            },
            {
              section: "corporate.catalog.courses",
              text: t("courses"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "courses",
              image: "section-courses.jpg",
            },
            {
              section: "corporate.catalog.activities",
              text: t("activities"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "activities",
              image: "section-activities.jpg",
            },
            {
              section: "corporate.catalog.users-waiting",
              text: t("users-waiting"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "users-waiting",
              image: "section-users-waiting.jpg",
            },
            {
              section: "corporate.catalog.overall-catalog",
              text: t("overall-catalog"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "overall-catalog",
              image: "section-overall-catalog.jpg",
              children: [
                {
                  section: "corporate.overallcatalog.paths",
                  text: t("paths-standalone"),
                  buttonLabel: t("manageButton", { ns: "common" }),
                  to: "paths-standalone",
                  image: "section-paths.jpg",
                },
                {
                  section: "corporate.overallcatalog.courses",
                  text: t("courses-standalone"),
                  buttonLabel: t("manageButton", { ns: "common" }),
                  to: "courses-standalone",
                  image: "section-courses.jpg",
                },
                {
                  section: "corporate.overallcatalog.activities",
                  text: t("activities-standalone"),
                  buttonLabel: t("manageButton", { ns: "common" }),
                  to: "activities-standalone",
                  image: "section-activities.jpg",
                },
              ],
            },
          ],
        },
        {
          section: "mediamanager.media.exercise.read",
          text:
            id === "1"
              ? t("corporate.facultiesArea.title")
              : t("corporate.teachersArea.title"),
          description: t("corporate.teachersArea.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "teachers",
          image: "section-teachers.jpg",
          children: [
            {
              section: "mediamanager.media.exercise.read",
              text: t("exercise-and-reviews"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "exercise-and-review",
              image: "section-exercise.jpg",
            },
            {
              section: "mediamanager.media.exercise.read",
              text: t("my-classes"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "my-classes",
              image: "section-my-classes.jpg",
            },
          ],
        },
        // {
        //   section: "corporate.quicksight",
        //   text: t("corporate.quicksight.title"),
        //   description: t("corporate.quicksight.description"),
        //   buttonLabel: t("manageButton", { ns: "common" }),
        //   to: "quicksight",
        //   image: "section-quicksight.jpg",
        // },

        {
          section: "learning_catalogue.learning_object.write",
          text: t("corporate.survey.title"),
          description: t("corporate.survey.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "survey",
          image: "section-survey.jpg",
        },
        {
          section: "editions.toj.retrieve",
          text: t("corporate.toj.title"),
          description: t("corporate.toj.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "toj-edition",
          image: "section-toj.jpg",
        },
        {
          section: "corporate.notifications",
          text: t("corporate.Notifications.title"),
          description: t("corporate.Notifications.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "notifications",
          image: "section-notification.jpg",
        },
        {
          section: "usermgmt.corporates.funded_training.write",
          text: t("corporate.foundedTraining.title"),
          description: t("corporate.foundedTraining.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "foundedTraining",
          image: "section-budget-management.jpg",
          children: [
            {
              section: "usermgmt.corporates.funded_training.read",
              text: t("corporate.foundedTraining.managementPlans.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "managePlan",
              image: "section-exercise.jpg",
            },
          ],
        },
        {
          section: "selfsignup",
          text: t("corporate.selfsignup.title"),
          description: t("corporate.selfsignup.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "selfsignup",
          image: "section-selfsignup.jpg",
          children: [
            {
              section: "selfsignup.rules",
              text: t("selfsignup.rules.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "rules",
              image: "section-selfsignup-rules.jpg",
            },
            {
              section: "selfsignup.form",
              permission: "usermgmt.selfsignup.configs.write",
              text: t("selfsignup.form.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "form",
              image: "section-selfsignup-form.jpg",
            },
          ],
        },
        {
          section: "usermgmt.corporates.training_needs",
          text: t("corporate.training-needs.title"),
          description: t("corporate.training-needs.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "training-needs",
          image: "section-training-needs.jpg",
        },
        {
          section: "usermgmt.budget.read",
          text: t("corporate.budget-management.title"),
          description: t("corporate.budget-management.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "budget-management",
          image: "section-budget-management.jpg",
        },
        {
          section: "smartconfigurator.quicksight.read",
          text: t("corporate.dashboard.title"),
          description: t("corporate.dashboard.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "dashboard",
          image: "section-dashboard.jpg",
          children: [
            {
              section: "smartconfigurator.quicksight.associate.users.roles",
              text: t("corporate.dashboard.users-roles.title"),
              description: t("corporate.dashboard.users-roles.description"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "users-roles",
              image: "section-dashboard-enable.jpg",
            },
            {
              section: "smartconfigurator.quicksight.read",
              text: t("corporate.dashboard.visualization.title"),
              description: t("corporate.dashboard.visualization.description"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "visualization",
              image: "section-dashboard-associate.jpg",
            },
          ],
        },
        {
          section: "usermgmt.corporates.collect_campaign.read",
          text: t("corporate.campaigns.title"),
          description: t("corporate.campaigns.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "collect-campaigns",
          image: "section-collect-campaigns.jpg",
        },
        {
          section: "attributes",
          text: t("corporate.attributes.title"),
          description: t("corporate.attributes.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "attributes",
          image: "section-corp-initiatives.jpg",
        },
      ],
    },
    {
      section: "faculties",
      text: t("faculties.title"),
      description: t("faculties.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "faculties",
      image: "section-faculties.jpg",
    },
    {
      section: "skills.profession.retrieve",
      text: t("skills.title"),
      description: t("skills.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "skills",
      image: "section-skills.jpg",
      children: [
        {
          section: "skills.industry.retrieve",
          text: t("skills.industries.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "industries",
          image: "section-skills-industry.jpg",
          settingsLink: "users-custom-fields",
          settingButtonTitle: "multilanguage-button-label",
          settingIcon: "multilanguage",
          permissionSettingsLink: "skills.industry.retrieve",
        },
        {
          section: "skills.profession.retrieve",
          text: t("skills.jobs-catalog.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "professions",
          image: "section-skills-jobs.jpg",
          settingsLink: "users-custom-fields",
          settingButtonTitle: "multilanguage-button-label",
          settingIcon: "multilanguage",
          permissionSettingsLink: "skills.profession.retrieve",
        },
        {
          section: "skills.knowledge.area.retrieve",
          text: t("skills.knowledge-catalog.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "knowledge-areas",
          image: "section-skills-knowledge.jpg",
          settingsLink: "users-custom-fields",
          settingButtonTitle: "multilanguage-button-label",
          settingIcon: "multilanguage",
          permissionSettingsLink: "skills.knowledge.area.retrieve",
        },
        {
          section: "skills.capabilities.retrieve",
          text: t("skills.capabilities.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "capabilities",
          image: "section-skills-capabilities.jpg",
          settingsLink: "users-custom-fields",
          settingButtonTitle: "multilanguage-button-label",
          settingIcon: "multilanguage",
          permissionSettingsLink: "skills.capabilities.retrieve",
        },
        {
          section: "skills.job.knowledge.suggestion.read",
          text: t("skills.suggestions.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "suggestions-job",
          image: "section-skills-suggestions.jpg",
        },
        {
          section: "skills.validation-autotagging",
          text: t("skills.validation-autotagging.title"),
          buttonLabel: t("uploadButton", { ns: "common" }),
          to: "validation-autotagging",
          image: "section-skills-validation.jpg",
          modalTitle: modalT("permissions"),
        },
      ],
    },
    {
      section: "users.site.retrieve",
      text: t("corporate.locations.title"),
      description: t("corporate.locations.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "locations",
      image: "section-locations.jpg",
    },
    {
      section: "badge-certificates",
      text: t("badge-certificates.title"),
      description: t("badge-certificates.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "badge-certificates",
      image: "section-badge-certificate.jpg",
      children: [
        {
          section: "badge-certificates.badge",
          permission: "fe.badge.template.read",
          text: t("badge-certificates.badge.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "badges",
          image: "section-badges.jpg",
        },
        {
          section: "badge-certificates.certificates",
          permission: "fe.certificate.template.read",
          text: t("badge-certificates.certificates.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "certificates",
          image: "section-certificates.jpg",
        },
        {
          section: "badge-certificates.skillBook",
          permission: "fe.external.certificate.read",
          text: t("corporate.badge-certificates.skillBook.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "skillBook",
          image: "section-skillbook.jpg",
        },
      ],
    },
    {
      section: "usermgmt.budget.read",
      text: t("budget-management.title"),
      description: t("budget-management.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "budget-management",
      image: "section-budget-management.jpg",
      children: [
        {
          section: "budget-management.budget",
          text: t("budget-management.budget.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "budgets",
          image: "section-budget.jpg",
        },
        {
          section: "budget-management.project",
          text: t("budget-management.project.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "projects",
          image: "section-project.jpg",
        },
        {
          section: "budget-management.accounting",
          text: t("budget-management.accounting.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "accounting",
          image: "section-accounting.jpg",
        },
        {
          section: "budget-management.setup",
          text: t("budget-management.setup.title"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "setup",
          image: "section-setup.jpg",
          children: [
            {
              section: "budget-management.setup.costcenter",
              text: t("budget-management.setup.costcenter.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "cost-centers",
              image: "section-cost-centers.jpg",
            },
            {
              section: "budget-management.setup.bankaccount",
              text: t("budget-management.setup.bankaccount.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "accounts",
              image: "section-accounts.jpg",
            },
            {
              section: "budget-management.setup.customer",
              text: t("budget-management.setup.customer.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "customers",
              image: "section-customers.jpg",
            },
            {
              section: "budget-management.setup.scope",
              text: t("budget-management.setup.scope.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "scopes",
              image: "section-scopes.jpg",
            },
            {
              section: "budget-management.setup.supplier",
              text: t("budget-management.setup.supplier.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "suppliers",
              image: "section-suppliers.jpg",
            },
            {
              section: "budget-management.setup.contract",
              text: t("budget-management.setup.contract.title"),
              buttonLabel: t("manageButton", { ns: "common" }),
              to: "contracts",
              image: "section-contracts.jpg",
            },
          ],
        },
      ],
    },
    {
      section: "media-library",
      text: t("media-library.title"),
      description: t("media-library.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "media-library",
      iconText: "library",
      image: "section-library.jpg",
    },
    {
      section: "users",
      text: t("users-digited.title"),
      description: t("users-digited.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "users",
      iconText: "skills",
      image: "section-users.jpg",
    },
    {
      section: "third-parts",
      text: t("third-parts.title"),
      description: t("third-parts.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "third-parts",
      // iconText: "skills",
      image: "section-third-parts.jpg",
      children: [
        {
          section: "third-parts.freshdesk",
          image: "freshdesk.png",
          text: t("third-parts.freshdesk.title"),
          description: t("third-parts.freshdesk.description"),
          buttonLabel: t("externalButton", { ns: "common" }),
          link: "https://support.freshdesk.com/en/support/home",
          external: true,
        },
        {
          section: "third-parts.accredible",
          image: "accredible.png",
          text: t("third-parts.accredible.title"),
          description: t("third-parts.accredible.description"),
          buttonLabel: t("externalButton", { ns: "common" }),
          link: "https://www.accredible.com/?utm_term=digital%20credential&utm_campaign=Generic+Research+Keywords&utm_source=adwords&utm_medium=ppc&hsa_cam=17825193541&hsa_tgt=kwd-304131253183&hsa_kw=digital%20credential&hsa_ver=3&hsa_ad=628295742609&hsa_acc=1256367924&hsa_grp=144967924771&hsa_src=g&hsa_net=adwords&hsa_mt=b&gclid=Cj0KCQjwmZejBhC_ARIsAGhCqnfJELwKtyOYAkkLsvtTE-p5LVIS3HF27ZyX7aoQKy8xRbf7GiDvxOMaAtHXEALw_wcB",
          external: true,
        },
        {
          section: "third-parts.lti_account",
          text: t("third-parts.lti_account.title"),
          description: t("third-parts.lti_account.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "lti-accounts",
          iconText: "skills",
          image: "section-users.jpg",
        },
      ],
    },
    {
      section: "editions.toj.retrieve",
      text: t("corporate.toj.title"),
      description: t("corporate.toj.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "toj-edition",
      image: "section-toj.jpg",
    },
    {
      section: "training-needs",
      text: t("training.title"),
      description: t("training.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "training-needs",
      image: "section-corporate.jpg",
      children: [
        {
          section: "training_needs.campaign.read",
          text: t("training.create.title"),
          description: t("training.create.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "create-management",
          image: "section-training-needs-create.jpg",
        },
        {
          section: "training_needs.campaign.complete.read",
          text: t("training.campaign.title"),
          description: t("training.campaign.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "completation-campaign",
          image: "section-training-needs-campaign.jpg",
        },
      ],
    },
    // {
    //   section: "permissions",
    //   text: t("permissions.title"),
    //   description: t("permissions.description"),
    //   buttonLabel: t("uploadButton", { ns: "common" }),
    //   to: "permissions",
    //   // iconText: "file",
    //   image: "section-permissions.jpg",
    //   modalTitle: modalT("permissions"),
    // },
    // {
    //   section: "quicksight",
    //   text: t("corporate.quicksight.title"),
    //   description: t("corporate.quicksight.description"),
    //   buttonLabel: t("manageButton", { ns: "common" }),
    //   to: `quicksight`,
    //   image: "section-quicksight.jpg",
    // },
    {
      section: "mediamanager.media.exercise.read",
      text: t("corporate.facultiesArea.title"),
      description: t("corporate.teachersArea.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "teachers",
      image: "section-teachers.jpg",
      children: [
        {
          section: "mediamanager.media.exercise.read",
          text: t("exercise-and-reviews"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "exercise-and-review",
          image: "section-exercise.jpg",
        },
        {
          section: "mediamanager.media.exercise.read",
          text: t("my-classes"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "my-classes",
          image: "section-my-classes.jpg",
        },
      ],
    },
    {
      //TODO: mettere il permesso giusto che arriverà da BE
      section: "usermgmt.global.maintenance.write",
      text: t("corporate.maintenancePage.title"),
      description: t("corporate.maintenancePage.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "permissions",
      image: "section-maintenancePage.jpg",
      modalTitle: modalT("permissions"),
    },
    {
      section: "smartconfigurator.quicksight.read",
      text: t("dashboard.title"),
      description: t("dashboard.description"),
      buttonLabel: t("manageButton", { ns: "common" }),
      to: "dashboard",
      image: "section-dashboard.jpg",
      children: [
        {
          section: "smartconfigurator.quicksight.import.dashboards",
          text: t("dashboard.enable-dashboard.title"),
          description: t("dashboard.enable-dashboard.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "enablement",
          image: "section-dashboard-enable.jpg",
        },
        {
          section: "smartconfigurator.quicksight.associate.corporates",
          text: t("dashboard.associate-corporate.title"),
          description: t("dashboard.associate-corporate.description"),
          buttonLabel: t("manageButton", { ns: "common" }),
          to: "corporate-association",
          image: "section-dashboard-associate.jpg",
        },
      ],
    },
  ];

  return navigation;
};

export const useMenu = () => {
  const { user } = useAuth();
  let navigation = useNavigaionRoutes();

  //TODO: remove mock permission corporate.maintenancePage
  return (
    (navigation &&
      navigation.filter(
        (menuItem) => user && user.permissions?.includes(menuItem.section),
      )) ||
    []
  );
};
